// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Stack$Showside from "./Stack.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as SmartImg$Showside from "./SmartImg.bs.js";
import * as Smartbar$Showside from "./Smartbar.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as IconPIPExpand$Showside from "../icons/IconPIPExpand.bs.js";
import * as QuickViewTabs$Showside from "../components/QuickViewTabs.bs.js";
import * as SmartNavVideo$Showside from "../components/SmartNavVideo.bs.js";
import * as QuickViewMedia$Showside from "../components/QuickViewMedia.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as QuickViewButton$Showside from "../components/QuickViewButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ShopifyAnalytics$Showside from "./ShopifyAnalytics.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseAutoplayProgress$Showside from "../hook/UseAutoplayProgress.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UseQuickViewPagination$Showside from "../hook/UseQuickViewPagination.bs.js";
import * as PictureInPictureContext$Showside from "./PictureInPictureContext.bs.js";
import * as PictureInPicture2SessionStorage$Showside from "./PictureInPicture2SessionStorage.bs.js";
function PictureInPicture2$PiP(Props) {
  var mediaId = Props.mediaId;
  var zIndex = Props.zIndex;
  var width = Props.width;
  var height = Props.height;
  var isPausedOpt = Props.isPaused;
  var interactiveOpt = Props.interactive;
  var handleClose = Props.handleClose;
  var render = Props.render;
  var renderHover = Props.renderHover;
  var renderOverlay = Props.renderOverlay;
  var maxSize = Props.maxSize;
  var positionOpt = Props.position;
  var isPaused = isPausedOpt !== undefined ? isPausedOpt : false;
  var interactive = interactiveOpt !== undefined ? interactiveOpt : true;
  var position = positionOpt !== undefined ? positionOpt : "left";
  ConfigurationProvider$Showside.use(undefined);
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var ratio = width / height;
  var maxSize$1 = Belt_Option.getWithDefault(maxSize, isMobile ? 150 : 300);
  var match$1 = ratio > 1 ? [maxSize$1, maxSize$1 / ratio] : [maxSize$1 * ratio, maxSize$1];
  var height$1 = match$1[1];
  var width$1 = match$1[0];
  var match$2 = React.useState(function () {
    return false;
  });
  var setHover = match$2[1];
  var hover = match$2[0];
  var handleMouseEnter = function (param) {
    Curry._1(setHover, function (param) {
      return true;
    });
  };
  var handleMouseLeave = function (param) {
    Curry._1(setHover, function (param) {
      return false;
    });
  };
  React.useEffect(function () {
    Curry._1(setHover, function (param) {
      return false;
    });
  }, [mediaId]);
  var renderHover$1 = Belt_Option.getWithDefault(renderHover, function (param) {
    return React.createElement(React.Fragment, undefined, React.createElement(QuickViewButton$Showside.make, {
      className: CSS$Showside.prefix("absolute inset-1/2 w-9 h-9 text-white z-20 transform -translate-x-1/2 -translate-y-1/2"),
      onClick: function (param) {
        Curry._1(handleClose, undefined);
      },
      children: React.createElement(IconPIPExpand$Showside.make, {
        className: CSS$Showside.prefix("w-8 h-8")
      }),
      block: false,
      flex: true
    }), React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 bg-gray-700 opacity-40 z-10"),
      onClick: function (param) {
        Curry._1(handleClose, undefined);
      }
    }));
  });
  var renderOverlay$1 = Belt_Option.getWithDefault(renderOverlay, function (param) {
    return React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 z-0"),
      onClick: function (param) {
        if (isMobile) {
          return Curry._1(handleClose, undefined);
        } else {
          return Curry._1(setHover, function (value) {
            return !value;
          });
        }
      }
    });
  });
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "pip",
    portal: true,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["fixed bottom-2 cursor-pointer", position === "right" ? "right-12" : "left-2", interactive ? "" : "pointer-events-none"])),
      id: "maker-smartnav-pip",
      style: {
        height: "" + String(height$1) + "px",
        width: "" + String(width$1) + "px",
        zIndex: String(Belt_Option.mapWithDefault(zIndex, 10000000, CSS$Showside.safeIncrementZIndex))
      },
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, Curry._3(render, width$1, height$1, hover), hover || isPaused ? Curry._1(renderHover$1, undefined) : null, Curry._1(renderOverlay$1, undefined))
  });
}
PictureInPicture2$PiP.displayName = "PictureInPicture2.PiP";
var PiP = {
  make: PictureInPicture2$PiP
};
function PictureInPicture2$MediaPiP(Props) {
  var zIndex = Props.zIndex;
  var match = PictureInPictureContext$Showside.use(undefined);
  var setMuted = match.setMuted;
  var saveTime = match.saveTime;
  var setMediaId = match.setMediaId;
  var muted = match.muted;
  var time = match.time;
  var backLocation = match.backLocation;
  var mediaId = match.mediaId;
  var config = UseQuickViewPagination$Showside.useQuickViewPagination(backLocation, undefined);
  var media = Belt_Array.getBy(config.media, function (m) {
    return Caml_obj.equal(m.id, mediaId);
  });
  var match$1 = UseAutoplayProgress$Showside.use(true, media, undefined, undefined, undefined);
  var setProgressRef = match$1[2];
  var setProgress = match$1[1];
  var progressSpeed = match$1[0];
  var curIndex = mediaId !== undefined ? Belt_Option.getWithDefault(Belt_Array.getIndexBy(config.media, function (m) {
    return m.id === mediaId;
  }), 0) : 0;
  var goToSlide = function (index) {
    Curry._1(setProgress, 0);
    if (setMediaId !== undefined) {
      return Curry._5(setMediaId, backLocation, undefined, undefined, muted, Belt_Option.map(Belt_Array.get(config.media, index), function (media) {
        return media.id;
      }));
    }
  };
  var next = function (param) {
    var nextIndex = curIndex + 1 | 0;
    goToSlide(nextIndex < config.media.length ? nextIndex : 0);
  };
  var autoplayTimerRef = React.useRef(undefined);
  React.useEffect(function () {
    var $$clearTimeout$1 = function (param) {
      var id = autoplayTimerRef.current;
      if (id !== undefined) {
        clearTimeout(Caml_option.valFromOption(id));
        return;
      }
    };
    $$clearTimeout$1(undefined);
    var kind = Belt_Option.map(media, function (m) {
      return m.kind;
    });
    if (kind === "image") {
      autoplayTimerRef.current = Caml_option.some(setTimeout(next, 5000));
    }
    return function (param) {
      $$clearTimeout$1(undefined);
    };
  }, [Belt_Option.mapWithDefault(media, "", function (m) {
    return m.id;
  })]);
  var currentTime = React.useRef(0);
  var handleClose = function (param) {
    if (setMediaId !== undefined) {
      return Curry._5(setMediaId, backLocation, currentTime.current, undefined, undefined, undefined);
    }
  };
  var handleTimeChange = function (time, duration) {
    currentTime.current = time;
    var progress = Math.round(time / duration * 100) | 0;
    Curry._1(setProgress, progress);
    if (saveTime !== undefined) {
      return Curry._1(saveTime, time);
    }
  };
  var match$2 = React.useState(function () {
    return false;
  });
  var setIsPaused = match$2[1];
  var isPaused = match$2[0];
  React.useEffect(function () {
    Curry._1(setIsPaused, function (param) {
      return false;
    });
  }, [mediaId]);
  var noop = function (param) {};
  var noopReact = function (param) {
    return null;
  };
  if (media === undefined) {
    return null;
  }
  var tmp = {
    mediaId: mediaId,
    width: media.originalWidth,
    height: media.originalHeight,
    isPaused: isPaused,
    handleClose: handleClose,
    render: function (width, height, hover) {
      var tmp = {
        mediaId: media.id,
        index: 0,
        total: 1,
        autoplay: true,
        setProgressRef: setProgressRef,
        position: "right",
        size: "sm"
      };
      if (progressSpeed !== undefined) {
        tmp.progressSpeed = progressSpeed;
      }
      var match = media.kind;
      var match$1 = media.kind;
      var tmp$1;
      var exit = 0;
      if (match$1 === "video" && (hover || isPaused)) {
        exit = 1;
      } else {
        tmp$1 = null;
      }
      if (exit === 1) {
        tmp$1 = React.createElement(QuickViewButton$Showside.make, {
          className: CSS$Showside.prefix("absolute top-6 right-5 text-white z-20"),
          onClick: function (param) {
            Curry._1(setIsPaused, function (value) {
              return !value;
            });
          },
          children: isPaused ? React.createElement(Unicons$Showside.UilPlay.make, {
            size: /* Px */{
              _0: 18
            }
          }) : React.createElement(Unicons$Showside.UilPause.make, {
            size: /* Px */{
              _0: 18
            }
          }),
          block: false,
          flex: true
        });
      }
      return React.createElement("div", {
        className: CSS$Showside.prefix("shadow-xl bg-black")
      }, QuickViewMedia$Showside.renderMedia(config.media, media, curIndex, curIndex, isPaused, false, false, Belt_Option.getWithDefault(time, 0), handleTimeChange, true, muted, false, goToSlide, noop, noop, noop, noop, noopReact, undefined), React.createElement(QuickViewTabs$Showside.make, tmp), muted && setMuted !== undefined && match === "video" ? React.createElement(QuickViewButton$Showside.make, {
        className: CSS$Showside.prefix("absolute top-3 left-3 p-2 text-white z-20 bg-gray-700 rounded-full"),
        onClick: function (param) {
          Curry._1(setMuted, false);
        },
        children: React.createElement(Unicons$Showside.UilVolumeMute.make, {
          size: /* Px */{
            _0: 18
          }
        }),
        block: false,
        flex: true
      }) : null, tmp$1);
    }
  };
  if (zIndex !== undefined) {
    tmp.zIndex = Caml_option.valFromOption(zIndex);
  }
  return React.createElement(PictureInPicture2$PiP, tmp);
}
PictureInPicture2$MediaPiP.displayName = "PictureInPicture2.MediaPiP";
var make = React.memo(PictureInPicture2$MediaPiP);
var MediaPiP = {
  make: make
};
function PictureInPicture2$ProductsPiP(Props) {
  var products = Props.products;
  var zIndex = Props.zIndex;
  var settings = Props.settings;
  var account = Props.account;
  var onClick = Props.onClick;
  var title = Props.title;
  var firstImage = Props.firstImage;
  var firstVideo = Props.firstVideo;
  var size = Belt_Option.mapWithDefault(account, "sm", function (account) {
    return account.pdpStackSize;
  });
  var position = Belt_Option.mapWithDefault(account, "left", function (account) {
    return account.pdpStackPosition;
  });
  var offsetLeft = Belt_Option.map(account, function (account) {
    return account.pdpStackOffset.left;
  });
  var offsetRight = Belt_Option.map(account, function (account) {
    return account.pdpStackOffset.right;
  });
  var offsetBottom = Belt_Option.map(account, function (account) {
    return account.pdpStackOffset.bottom;
  });
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = size === "sm" ? isMobile ? [70, 70, 70] : [100, 100, 100] : isMobile ? [100, 100, 100] : [150, 150, 150];
  var getItems = function (width, height) {
    var products$1 = Belt_Array.keepMap(Belt_Array.reverse(products), function (product) {
      var image = Belt_Array.get(Product$Showside.getValidProductImages(product), 0);
      return Belt_Option.map(image, function (image) {
        return [image, undefined];
      });
    });
    var products$2 = firstImage !== undefined ? Belt_Array.concat(products$1, [[firstImage, firstVideo]]) : firstVideo !== undefined ? Belt_Array.concat(products$1, [[firstImage, firstVideo]]) : products$1;
    var products$3 = Belt_Array.slice(products$2, -3, 3);
    return Belt_Array.mapWithIndex(products$3, function (index, param) {
      var video = param[1];
      var image = param[0];
      return [Belt_Option.getWithDefault(Belt_Option.mapWithDefault(image, video, function (image) {
        return image;
      }), String(index)), function (param) {
        var tmp;
        if (video !== undefined) {
          var tmp$1 = {
            src: video,
            autoplay: settings.videoAutoPlay,
            loop: settings.videoLoop,
            muted: settings.videoMute,
            controls: settings.videoControls
          };
          if (image !== undefined) {
            tmp$1.poster = image;
          }
          tmp = React.createElement("div", {
            className: CSS$Showside.prefix("absolute max-w-full max-h-full m-2 inset-0")
          }, React.createElement(SmartNavVideo$Showside.make, tmp$1));
        } else {
          tmp = image !== undefined ? React.createElement(SmartImg$Showside.Sized.make, {
            src: image,
            containerWidth: width - 12 | 0,
            containerHeight: height - 12 | 0,
            fit: /* Cover */1,
            priority: 0
          }) : null;
        }
        return React.createElement("div", {
          className: CSS$Showside.prefix("bg-white p-2 relative"),
          style: {
            height: String(height) + "px",
            width: String(width) + "px"
          }
        }, tmp, title !== undefined && index === (products$3.length - 1 | 0) ? React.createElement("div", {
          className: CSS$Showside.prefix("absolute w-full h-full inset-0 p-2 flex items-center justify-center text-white text-center")
        }, React.createElement("div", {
          className: CSS$Showside.prefix("absolute max-w-full max-h-full m-2 inset-0 bg-black bg-opacity-30")
        }), React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["max-w-full filter drop-shadow font-bold tracking-widest leading-normal uppercase break-words", size === "sm" && isMobile ? "text-xs" : ""]))
        }, title)) : null);
      }, onClick];
    });
  };
  if (products.length === 0) {
    return null;
  }
  var tmp = {
    mediaId: "product",
    width: match$1[0],
    height: match$1[1],
    interactive: false,
    handleClose: function (param) {},
    render: function (width, height, hover) {
      var width$1 = width | 0;
      var height$1 = height | 0;
      var tmp = {
        maxThumbnails: 3,
        items: getItems(width$1, height$1),
        direction: /* Fan */2,
        width: width$1,
        height: height$1,
        rotation: position === "right" ? /* Positive */1 : /* Negative */0
      };
      if (offsetLeft !== undefined) {
        tmp.offsetLeft = Caml_option.valFromOption(offsetLeft);
      }
      if (offsetRight !== undefined) {
        tmp.offsetRight = Caml_option.valFromOption(offsetRight);
      }
      if (offsetBottom !== undefined) {
        tmp.offsetBottom = Caml_option.valFromOption(offsetBottom);
      }
      return React.createElement("div", {
        className: CSS$Showside.prefix("-mt-8")
      }, React.createElement(Stack$Showside.make, tmp));
    },
    renderHover: function (param) {
      return React.createElement(React.Fragment, undefined);
    },
    renderOverlay: function (param) {
      return React.createElement(React.Fragment, undefined);
    },
    maxSize: match$1[2],
    position: position
  };
  if (zIndex !== undefined) {
    tmp.zIndex = Caml_option.valFromOption(zIndex);
  }
  return React.createElement(PictureInPicture2$PiP, tmp);
}
PictureInPicture2$ProductsPiP.displayName = "PictureInPicture2.ProductsPiP";
var ProductsPiP = {
  make: PictureInPicture2$ProductsPiP
};
function PictureInPicture2$ProductPiP(Props) {
  var storeId = Props.storeId;
  var smartnavApiHost = Props.smartnavApiHost;
  var productId = Props.productId;
  var zIndex = Props.zIndex;
  var settings = Props.settings;
  var account = Props.account;
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = UseApi$Showside.useRelatedProducts(productId, storeId, "", true, true, smartnavApiHost, match.market, undefined);
  var products = Belt_Array.concatMany(Belt_Array.map(Belt_Option.getWithDefault(match$1.data, []), function (page) {
    return page.products;
  }));
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$2.goTo;
  var onClick = function (param) {
    Curry._3(goTo, undefined, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Product */1,
          _0: productId
        },
        viewPLP: true,
        filters: undefined,
        sort: undefined
      }
    });
  };
  var match$3 = ViewportContext$Showside.use(undefined);
  var tmp = {
    products: products,
    settings: settings,
    onClick: onClick,
    title: match$3.isMobile ? "Related" : "Related Products"
  };
  if (zIndex !== undefined) {
    tmp.zIndex = Caml_option.valFromOption(zIndex);
  }
  if (account !== undefined) {
    tmp.account = Caml_option.valFromOption(account);
  }
  return React.createElement(PictureInPicture2$ProductsPiP, tmp);
}
PictureInPicture2$ProductPiP.displayName = "PictureInPicture2.ProductPiP";
var ProductPiP = {
  make: PictureInPicture2$ProductPiP
};
function PictureInPicture2$CategoryPiP(Props) {
  var storeId = Props.storeId;
  var category = Props.category;
  var categoryId = Props.categoryId;
  var productId = Props.productId;
  var zIndex = Props.zIndex;
  var settings = Props.settings;
  var account = Props.account;
  var smartnavApiHost = Props.smartnavApiHost;
  var featuredProductsIds = Category$Showside.getProductIds(category);
  var shouldFetchFeaturedProducts = featuredProductsIds.length !== 0;
  var match = EntrypointContext$Showside.use(undefined);
  var market = match.market;
  var match$1 = UseApi$Showside.useProductsById(storeId, featuredProductsIds, true, shouldFetchFeaturedProducts, categoryId, smartnavApiHost, market, undefined);
  var defaultFilters = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return Category$Showside.ExternalConnection.getFilterBy(connection, account);
  });
  var match$2 = UseApi$Showside.useCategoryProducts(undefined, storeId, categoryId, Category$Showside.ExternalConnection.getStoreCategoryConnection(category), true, undefined, defaultFilters, 4, undefined, featuredProductsIds.length < 3, smartnavApiHost, undefined, market, undefined);
  var products = Belt_Array.concatMany(Belt_Array.map(Belt_Option.getWithDefault(match$2.swr.data, []), function (page) {
    return page.products;
  }));
  var featuredProducts = Belt_Option.getWithDefault(match$1.products, []);
  var products$1 = Belt_Array.keep(Belt_Array.concat(featuredProducts, products), function (p) {
    return p.id !== productId;
  });
  ConfigurationProvider$Showside.use(undefined).config;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$3.goTo;
  var onClick = function (param) {
    Curry._3(goTo, undefined, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: categoryId
        },
        viewPLP: true,
        filters: undefined,
        sort: undefined
      }
    });
  };
  var match$4 = category.card;
  var firstImage;
  var exit = 0;
  var imageUrl;
  switch (match$4.TAG | 0) {
    case /* ImageLinkCard */0:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoLinkCard */1:
      firstImage = match$4._0.fallbackImageUrl;
      break;
    case /* ImageCard */2:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoCard */3:
      firstImage = match$4._0.fallbackImageUrl;
      break;
    case /* MedialessCard */4:
    case /* MedialessLinkCard */5:
      firstImage = undefined;
      break;
    case /* ImageDisplayCard */6:
      imageUrl = match$4._0.imageUrl;
      exit = 1;
      break;
    case /* VideoDisplayCard */7:
      firstImage = match$4._0.fallbackImageUrl;
      break;
  }
  if (exit === 1) {
    firstImage = imageUrl !== "" ? imageUrl : undefined;
  }
  var match$5 = category.card;
  var firstVideo;
  var exit$1 = 0;
  var videoUrl;
  switch (match$5.TAG | 0) {
    case /* VideoLinkCard */1:
      videoUrl = match$5._0.videoUrl;
      exit$1 = 1;
      break;
    case /* VideoCard */3:
      videoUrl = match$5._0.videoUrl;
      exit$1 = 1;
      break;
    case /* VideoDisplayCard */7:
      videoUrl = match$5._0.videoUrl;
      exit$1 = 1;
      break;
    default:
      firstVideo = undefined;
  }
  if (exit$1 === 1) {
    firstVideo = videoUrl !== "" ? videoUrl : undefined;
  }
  var tmp = {
    products: products$1,
    settings: settings,
    onClick: onClick,
    title: category.title
  };
  if (zIndex !== undefined) {
    tmp.zIndex = Caml_option.valFromOption(zIndex);
  }
  if (account !== undefined) {
    tmp.account = Caml_option.valFromOption(account);
  }
  if (firstImage !== undefined) {
    tmp.firstImage = Caml_option.valFromOption(firstImage);
  }
  if (firstVideo !== undefined) {
    tmp.firstVideo = Caml_option.valFromOption(firstVideo);
  }
  return React.createElement(PictureInPicture2$ProductsPiP, tmp);
}
PictureInPicture2$CategoryPiP.displayName = "PictureInPicture2.CategoryPiP";
var CategoryPiP = {
  make: PictureInPicture2$CategoryPiP
};
function PictureInPicture2(Props) {
  var match = EntrypointContext$Showside.use(undefined);
  var smartnavApiHost = match.smartnavApiHost;
  var match$1 = PictureInPictureContext$Showside.use(undefined);
  var match$2 = ConfigurationProvider$Showside.use(undefined).config;
  var account = match$2.transitiveAccount;
  var storeId = match$2.transitiveStoreId;
  var settings = match$2.settings;
  var categories = match$2.categories;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var zIndex = settings.zIndexInt;
  var isSmartBarEnabled = Smartbar$Showside.isSmartBarEnabled(match.embedType) || match$3.route !== /* NotRendered */0;
  var productId = ShopifyAnalytics$Showside.getProductPageProductId(undefined);
  if (match$1.mediaId !== undefined) {
    return React.createElement(make, {
      zIndex: zIndex
    });
  }
  if (productId === undefined) {
    return null;
  }
  var pdpStackEnabled = Belt_Option.mapWithDefault(account, false, function (account) {
    return account.pdpStackEnabled;
  });
  var categoryId = PictureInPicture2SessionStorage$Showside.getFromSessionStorage("category");
  var category = Belt_Option.flatMap(categoryId, function (categoryId) {
    return Category$Showside.getCategoryById(categories, categoryId);
  });
  var enabled = pdpStackEnabled && !isSmartBarEnabled ? true : false;
  if (!enabled) {
    return null;
  }
  if (categoryId !== undefined && category !== undefined) {
    var tmp = {
      storeId: storeId,
      category: category,
      categoryId: categoryId,
      productId: productId,
      zIndex: zIndex,
      settings: settings,
      smartnavApiHost: smartnavApiHost
    };
    if (account !== undefined) {
      tmp.account = Caml_option.valFromOption(account);
    }
    return React.createElement(PictureInPicture2$CategoryPiP, tmp);
  }
  var tmp$1 = {
    storeId: storeId,
    smartnavApiHost: smartnavApiHost,
    productId: productId,
    zIndex: zIndex,
    settings: settings
  };
  if (account !== undefined) {
    tmp$1.account = Caml_option.valFromOption(account);
  }
  return React.createElement(PictureInPicture2$ProductPiP, tmp$1);
}
PictureInPicture2.displayName = "PictureInPicture2";
var make$1 = PictureInPicture2;
var $$default = PictureInPicture2;
export { PiP, MediaPiP, ProductsPiP, ProductPiP, CategoryPiP, make$1 as make, $$default, $$default as default };
/* make Not a pure module */